import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAG4d4bK4QF8hrSIFk1JjbwswBXabebkXU",
  authDomain: "house-marketplace-app-eb0eb.firebaseapp.com",
  projectId: "house-marketplace-app-eb0eb",
  storageBucket: "house-marketplace-app-eb0eb.appspot.com",
  messagingSenderId: "44645946729",
  appId: "1:44645946729:web:686b980e4ba37e853219f8",
};

// Initialize Firebase
initializeApp(firebaseConfig);
export const db = getFirestore();
